<template>
  <div class="order-list-wrapper" v-r-loading.fullscreen="pageLoading">
    <div class="header-box" v-if="isH5">
      <PageMbHeader
        :title="$t('我的订单')"
        :transShow="false"
        :transOpen="false"
        @icon-click="goBack"
      />
    </div>
    <p class="my-back" v-else-if="!isH5 && init" @click="goBack">
      <i class="el-icon-arrow-left" />
      {{ $t('FoodC_supplement_Return_wVpv') }}
    </p>
    <OrderSkeleton v-if="!init" />
    <template v-else-if="emptyType">
      <EmptyState :emptyType="emptyType" @tryAgain="refresh" />
    </template>
    <template v-else>
      <div class="list-wrapper">
        <List
          class="order-list-class"
          :disabled="disabled"
          :distance="distance"
          :load-more-status="loadMoreStatus"
          @more="loadMore"
        >
          <component
            class="style-box-class"
            :is="isH5 ? 'OrderMbCard' : 'OrderCard'"
            v-for="(item, index) in orderList"
            :key="'item' + index"
            :info="item"
            @action="cardAction"
          ></component>
        </List>
      </div>
    </template>
    <OrderDetailCardPopup
      v-model="showOrderDetailCard"
      :layoutCards="layoutCards"
      :orderId="orderData.orderId"
      :orderData="orderData"
      @confrimCard="confrimCard(orderData.orderId)"
      @confrimPay="confrimPay"
      @goIconUrl="goIconUrl"
    />
    <!-- 评价 -->
    <Evaluate
      v-if="popupVisible"
      ref="evaluateRef"
      :position="isH5 && 'bottom'"
      :orderId="selectOrderId"
      :status="selectStatus"
      :edit="evaEdit"
      @on-close="handleEvaPopHide"
      @on-success="handleEvaSuccess"
    />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { mapActions, mapState, mapMutations } from 'vuex';
import { requestCommonParams } from '@/lib/request/requestCommonParams';
import OrderSkeleton from '@/components/SkeletonComponents/orderSkeleton/orderSkeleton.vue';
import OrderCard from '@/components/OrderCard';
import OrderMbCard from '@/components/OrderCard/mbcard.vue';
import List from '@/components/List';
import PageMbHeader from '@/components/PageMbHeader';
import OrderDetailCardPopup from '@/components/OrderDetailPopup/cardDialog.vue';
import Evaluate from '@/components/Evaluate/index.vue';
import EmptyState from '@/components/EmptyState';
import { getLocalStorage } from '@/utils/localStorage';
import stopper from '@/utils/stopper';
import api from '@/api';
export default {
  name: 'Order',
  components: {
    OrderSkeleton,
    EmptyState,
    OrderCard,
    OrderMbCard,
    List,
    PageMbHeader,
    OrderDetailCardPopup,
    Evaluate,
  },
  data() {
    return {
      init: false,
      pageLoading: false,
      disabled: false,
      showOrderDetailCard: false,
      distance: 30,
      loadMoreStatus: 'suc', // 加载状态 suc fail nomore loading

      /** @desc 评价相关 */
      popupVisible: false,
      selectOrderId: '',
      selectStatus: '',
      evaluationItem: null,
      evaEdit: true,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      page: ({ order }) => order.page,
      listErrno: ({ order }) => order.listErrno,
      orderList: ({ order }) => order.orderList,
      hasMore: ({ order }) => order.hasMore,
      unfinished: ({ order }) => order.unfinished,
      layoutCards: ({ order }) => order.layoutCards,
      orderData: ({ order }) => order.orderData,
    }),
    emptyType() {
      let str = '';
      if (this.listErrno === -1) {
        // 错误 没有返回数据
        str = 'netNotResultData';
      } else if (this.orderList.length === 0) {
        // 没有订单
        str = 'noRecentOrders';
      }
      return str;
    },
  },
  async mounted() {
    this.initOpenPopup();
    this.refreshOrderList();
    await this.loadMore();
    this.init = true;
  },
  methods: {
    ...mapActions('order', [
      'getOrderList',
      'getPageBatchInfo',
      'getConfirmMeal',
      'getEvaTagList',
      'getEvaInfo',
    ]),
    ...mapActions('common', ['getToken']),
    ...mapMutations('order', ['refreshOrderList']),
    ...mapMutations('order', ['setOrderLoading']),
    goBack() {
      this.$router.back();
    },
    refresh() {
      // 详情返回时 调用
      this.refreshOrderList();
      this.loadMore();
    },
    async loadMore() {
      this.loadMoreStatus = 'loading';
      await this.getOrderList({
        pageNum: this.page,
      });
      this.setLoadStatus();
    },
    initOpenPopup() {
      let orderId = this.$route.query.orderId;
      let type = this.$route.query.type;
      if (!orderId || !type) return;
      this.cardAction(type, {
        status: 600, // 先全部当成已完成订单处理
        orderId: orderId,
      });
      if (type === 'evaluation') {
        let map = cloneDeep(this.$route.query);
        delete map.orderId;
        delete map.type;
        this.$router.replace({
          query: map,
        });
      }
    },
    setLoadStatus() {
      if (!this.hasMore) {
        this.loadMoreStatus = 'nomore';
      } else {
        this.loadMoreStatus = 'suc';
      }
    },
    cardAction(type, payload = {}) {
      // 按钮点击事件 展示详情等
      switch (type) {
        case 'store':
          // 跳转商家页 payload.shopId
          this.$router.push({
            path: `/store/${payload.shopId}`,
          });
          break;
        case 'detail':
          // 展示订单详情 未完成订单 跳页
          this.$trackEvent({
            eventId: 'sailing_c_x_myorder_order_ck',
            eventLabel: '订单列表点击单个订单',
            attrs: {
              order_id: payload.orderId + '',
              order_status: payload.status,
            },
          });
          if (this.isH5 || payload.status < 600) {
            this.$router.push({
              path: `/orderDetail/`,
              query: { orderId: payload.orderId },
            });
          } else {
            // 弹窗
            this.openOrderDetailCard(payload.orderId, 'initialize');
          }
          break;
        case 'evaluation':
          // 评价
          this.$trackEvent({
            eventId: 'sailing_c_x_evaluation_entrance_ck',
            eventLabel: '订单列表 评价按钮点击',
            attrs: {
              order_id: payload.orderId + '',
              order_status: payload.status,
              evaluation_status: 1,
            },
          });
          this.handleEvaluate(payload.item, payload.orderId, payload.status, payload.score);
          break;
        case 'lookEvaluation':
          //  查看评价
          this.$trackEvent({
            eventId: 'sailing_c_x_evaluation_entrance_ck',
            eventLabel: '订单列表 评价按钮点击',
            attrs: {
              order_id: payload.orderId + '',
              order_status: payload.status,
              evaluation_status: 2,
            },
          });
          this.handleLookEvaluate(payload.orderId, payload.status);
          break;
        case 'pay':
        case 'debts':
          // 支付 欠款
          if (this.isH5 || payload.status < 600) {
            this.$router.push({
              path: `/orderDetail/`,
              query: { orderId: payload.orderId },
            });
          } else {
            // 弹窗
            this.openOrderDetailCard(payload.orderId, 'initialize');
          }
          break;
        case 'oneMoreOrder':
          // 再来一单
          break;
      }
    },
    // 订单详情卡片 start
    async openOrderDetailCard(orderId, type) {
      this.pageLoading = true;
      await this.getPageBatchInfo({
        orderIds: orderId,
      });
      this.pageLoading = false;
      this.showOrderDetailCard = true;
    },

    async confrimCard(orderId) {
      // 调用完成取订单接口
      this.pageLoading = true;
      await this.getConfirmMeal({
        orderId: orderId,
      });
      this.openOrderDetailCard(orderId);
    },
    async confrimPay(val) {
      const {
        debtId,
        orderId,
      } = this.layoutCards?.OrderAbnormalInfo?.data?.orderAbnormalInfo?.debtInfo;

      try {
        // 卡
        const payChannel = {
          channelId: val?.channelID,
          cardPrefix: val?.card_prefix,
          clientPayType: 0, // clientPayType 端上发起支付方式。0-不走端上支付，1-三方支付（目前仅paypay）
          cardOrg: val?.card_org,
          alias: val?.alias,
          cardSuffix: val?.card_suffix,
          cardIndex: val?.card_index,
          channelName: val?.channelName,
          balance: val?.balance,
          cardType: 0,
        };

        this.setOrderLoading(true);
        stopper.start();
        let success = await api.getDebtRepay({
          debtId,
          orderId,
          payChannel: JSON.stringify(payChannel),
        });
        stopper.end();
        this.setOrderLoading(false);
        window.location.reload()
      } catch {}
    },
    goIconUrl(val) {
      if (val?.type == 'helpCard') {
        this.$trackEvent({
          eventId: 'sailing_c_x_orderpage_faq_button_ck',
          eventLabel: 'FAQ模块按钮点击',
          attrs: {
            order_id: this.orderData.orderId,
            order_status: this.orderData.status,
          },
        });
        // 帮助中心去往客服中心 ，需要解析参数
        this.getReplaceUrl(val?.url).then(url => {
          window.open(url);
        });
      } else {
        const { locale } = requestCommonParams();
        let url = val?.url.replace('${locale}', locale);
        window.open(url);
      }
    },
    async getReplaceUrl(url) {
      if (!this.isH5) {
        await this.getToken();
      }
      const offset = new Date().getTimezoneOffset();
      const { appVersion, lang, locale, osType } = requestCommonParams();

      const paramsObj = {
        '${utcOffset}': offset,
        '${appVersion}': appVersion,
        '${token}': getLocalStorage('ticket'),
        '${lang}': lang,
        '${locale}': locale,
        '${sodaType}': 'c',
        '${appPlatform}': osType,
        '${source}': 'soda_global_c_xcz',
      };
      let paramsUrl = url;
      Object.keys(paramsObj).forEach(key => {
        paramsUrl = paramsUrl.replace(key, paramsObj[key]);
      });
      return paramsUrl;
    },
    // 订单详情卡片 end

    /** @desc 订单评价 */
    async handleEvaluate(item, orderId, status, shopScore) {
      this.evaluationItem = item;

      this.pageLoading = true;
      await this.getEvaTagList({ orderId });
      this.pageLoading = false;

      this.evaEdit = true;
      this.selectOrderId = orderId;
      this.selectStatus = status;
      this.popupVisible = true;
      this.$nextTick(() => {
        // 设置评价店铺评分(星星)
        this.$refs['evaluateRef'].setShopScore(shopScore)
      })
    },
    // 评价关闭回调
    handleEvaPopHide() {
      this.popupVisible = false;
    },
    // 提交评价成功回调
    handleEvaSuccess(data) {
      // data: {orderId shopDesc shopScore riderScore}
      // 没有 evaluationItem 时用data.orderId 从 orderList 中获取
      if (!this.evaluationItem) {
        this.orderList.forEach(el => {
          if (el?.orderInfo?.orderId === data.orderId) {
            this.evaluationItem = el;
          }
        });
      }
      if (this.evaluationItem && data) {
        this.evaluationItem.evaluation = {
          shopEvaluation: {
            score: data.shopScore,
            scoreDesc: data.shopDesc,
          },
        };
        this.evaluationItem?.buttons?.forEach(item => {
          if (+item.type === 3) {
            item.type = 4;
            item.name = this.$t('查看评价');
          }
        });
      }
      this.popupVisible = false;
    },
    /** @desc 查看评价 */
    async handleLookEvaluate(orderId, status) {
      this.pageLoading = true;
      await this.getEvaInfo({ orderId });
      this.pageLoading = false;

      this.evaEdit = false;
      this.selectOrderId = orderId;
      this.selectStatus = status;
      this.popupVisible = true;
    },
  },
};
</script>
<style lang="scss">
.order-list-class {
  .bottom-btn {
    padding: 40px 0
  }
}
</style>
<style lang="scss" scoped>
.order-list-wrapper {
  margin: 0 auto;
  width: 1156px;
  min-height: calc(100vh - 60px);
  .my-back {
    display: inline-block;
    height: 60px;
    line-height: 60px;
    font-family: 'Aspira Medium';
    font-weight: 500;
    font-size: 20px;
  }
  .empty-state-content{
    height: calc(100vh - 240px)
  }
}
.header-box {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 100;
}
.style-box-class {
  margin-top: 20px;
  &:first-child {
    margin-top: 0;
  }
}
@media screen and (max-width: 768px) {
  .order-list-wrapper {
    width: 100%;
    min-height: 100px;
   .empty-state-content{
    height: auto
  }
  }
  .list-wrapper {
    padding: rem(40) rem(24) 0;
  }
  .header-box {
    height: rem(94);
  }
  .style-box-class {
    margin-top: rem(40);
  }
}
</style>
